// extracted by mini-css-extract-plugin
export default {"container":"ModalHeaderBasic_container__y74DJ","close":"ModalHeaderBasic_close__ODurB"};